export default __webpack_public_path__ + "static/media/GuessJobs1_02.65da2d2a.png";